import { createSelector, createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { DataTablePagination } from 'studio-components';
import { PaginationState, SortState } from './models';
import { createLoadSelectors, LoadSelectors } from '../load/selectors';
import { LoadFilter } from '../load/models';
import { LoadWithPaginationState } from './reducer';

export interface LoadWithPaginationSelectors<Entity> extends LoadSelectors<Entity> {
  selectPagination: MemoizedSelector<object, PaginationState>;
  selectSort: MemoizedSelector<object, SortState>;
  selectQuery: MemoizedSelector<object, SortState & DataTablePagination & LoadFilter>;
}

export function createLoadWithPaginationSelectors<Entity>(
  stateKey: string,
): LoadWithPaginationSelectors<Entity> {
  const loadSelectors = createLoadSelectors<Entity>(stateKey);
  const selectState = createFeatureSelector<LoadWithPaginationState<Entity>>(stateKey);
  const selectPagination = createSelector(selectState, ({ pagination }) => pagination);
  const selectSort = createSelector(selectState, ({ sort }) => sort);
  const selectQuery = createSelector(
    loadSelectors.selectFilter,
    selectPagination,
    selectSort,
    (filter, { limit, page }, sort) => ({
      limit,
      page,
      ...sort,
      ...filter,
    }),
  );

  return {
    ...loadSelectors,
    selectPagination,
    selectSort,
    selectQuery,
  };
}
